export const getHighlightedTitleFromSearch = (suggestion) =>
  // eslint-disable-next-line no-underscore-dangle
  suggestion?._highlightResult?.title?.value ?? null
